import Gauge from './gauge';
export default Gauge;